import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import MappingDetails from './MappingDetails';
import React, {useState} from 'react'



// const data = [
//   { id: 1, name: 'Snow', district: 'Jon', subdistrict: 'dsf',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 2, name: 'sdc', district: 'Jon', subdistrict: 'cx',dsname:'ram',mobile:'1234567890' ,email:"demo@gmail.com"},
//   { id: 3, name: 'Snow', district: 'Jon', subdistrict: 'ew',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 4, name: 'dc', district: 'Jon', subdistrict: 'sdf',dsname:null ,mobile:'1234567890',email:"demo@gmail.com"},
//   { id: 5, name: 'ds', district: 'Jon', subdistrict: 'zxc',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 6, name: 'as', district: 'Jon', subdistrict: 'ds',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 7, name: 'ds', district: 'Jon', subdistrict: 'zxc',dsname:null,mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 8, name: 'asd', district: 'Jon', subdistrict: 'zxc',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 9, name: 'zxc', district: 'Jon', subdistrict: 'zxc',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
// ];

export default function AgentTable(props) {
    const[Selected,setSelected]=useState(null)
    console.log(props);
    const data = props.data

    console.log("data",data);

    const handleButtonClick = (productId) => {
      setSelected(data.find((item)=>item._id===productId))
      props.setSelected(true)
    }
    const handleBack=()=>{
        setSelected(null)
        props.setSelected(false)
    }
    const columns = [
        { field: 'user_code', headerName: 'MDS Code', width: 90 },
        {
          field: 'first_name',
          headerName: 'Name',
          width: 200,
          editable: true,
        },
        {
          field: 'district',
          headerName: 'District',
          width: 150,
          editable: true,
        },
        {
          field: 'sub_district',
          headerName: 'Sub District',
          width: 110,
          editable: true,
        },
        {
          field: 'mapped_ds_name',
          headerName: 'TM Name',
          width: 200,
          editable: true,
        },
        {
          field: 'action',
          headerName: 'Action',
          width: 110,
          renderCell: (params) => {
            return (
              <Button variant="contained" color="secondary" onClick={() => handleButtonClick(params.row._id)}>
                {props.status==="mapped"?"Edit":"Map"} 
              </Button>
            );
          },
        },
        
      ];

   
  return (
    <Box sx={{ height: 400, width: '100%' }}>
    {
        Selected?
        <MappingDetails status={props.status} selected={Selected} handleBack={handleBack}/>
        :
        <DataGrid
        rows={data?data:[]}
        columns={columns}
        getRowId={(item)=>item._id}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
      />
    }
     
    </Box>
  );
}